const INDEXURL = 'https://apply-uk.atfx.com/'
const SERVER = 'https://ao-api-uk.atfx.com'
const GET_COUNTRY_CODE = "https://ipinfo.io";
const IsMaintain = false;    // true: show maintain page

const IsDev = false;  //false▒~Z▒~\▒▒~\▒▒~N▒▒~C▒~Ltrue▒~Zuat/prd▒~N▒▒~C,
const MU_APPLY_URL = "https://apply-int.atfx.com";
//const GET_COUNTRY_CODE_PRD = "https://ipapi.co/json/?key=8d4f82d1e42403a6a0b8d1e047df9ab827ea71bc";
const GET_COUNTRY_CODE_PRD = "https://ipapi.co/json";

module.exports = { SERVER,GET_COUNTRY_CODE,IsDev,INDEXURL,IsMaintain,MU_APPLY_URL,GET_COUNTRY_CODE_PRD};




// WEBPACK FOOTER //
// ./src/api/env.js